<template>
	<div class="position-relative">
		<div>
		<!-- <div class="sticky-top"> -->
			<div>
				<router-link to="/"><i class="fas fa-arrow-left"></i> {{ $t('back_to_general') }}</router-link>
			</div>
			<h3>Usage Tracker View</h3>
			<div class="mb-2 mt-2 border-bottom row">
				<label class="col-2 col-form-label text-right mb-2">Select user</label>
				<div class="col-10">
					<select
						v-model="user"
						class="form-control w-auto mb-2"
						@change="onUserSelected">
						<option v-for="user in users" :value="user" :key="user.id">{{ user.getUsageViewLabelText() }}</option>
					</select>
				</div>
				<template v-if="user">
					<label class="col-2 col-form-label text-right mb-2">Select date (optional)</label>
					<div class="col-10">
						<select v-model="dateYMD"
							class="form-control w-auto mb-2">
							<option v-for="dateYMD in appUsageItemDates" :value="dateYMD" :key="dateYMD">{{ dateYMD ? $dayjs(dateYMD).format('YYYY.MM.DD'): '' }}</option>
						</select>
					</div>
				</template>
			</div>
		</div>
		<template v-if="appUsageItemFiltered">
			<div class="row">
				<div class="col-6">
					<div v-for="item in appUsageItemFiltered" :key="item.id" class="mb-2 border-bottom">
						<h5>{{ $dayjs(item.dateYMD).format('YYYY.MM.DD') }}</h5>
						<div v-for="(session, idx) in item.data" :key="session.uuid + idx">
							<div v-for="(action, idx) in session.actions" :key="action.actionName + idx">
								<div class="ml-3 d-flex">
									<span>{{ `${action.time} ${action.usageViewInfo.descriptor}` }} <span class="font-italic">{{ action.usageViewInfo.family }}</span></span>
									<span class="ml-1" @mouseenter= "onMouseEnter(action)" @mouseleave= "onMouseLeave">{{ ` ${action.usageViewInfo.description}` }}
										<tippy-component
											v-if="action.usageViewInfo.title && showTooltip && currentAction === action"
											:animate-fill="false"
											arrow
											animation="fade"
											@onCreate="onCreateTippyHandler"
											distant="0"
											hideOnClick=true
											interactive
											maxWidth="none"
											placement="right"
											appendTo= "parent"
											flip="false"
											theme="light">
											<div class="bs-slc">
												<div class="tippy-tooltip-item-title p-2 text-left" :style="{'white-space':'pre-line'}">{{ action.usageViewInfo.title }}</div>
											</div>
										</tippy-component>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6 position-relative">
					<div class="sticky-top">
						<div v-for="feature in getUsageViewUserSummary" class="mb-2" :key="feature.descriptor">
							<div class="font-weight-bold">{{ feature.descriptor }}</div>
							<div :style="{'white-space':'pre-line'}">{{ feature.text }}</div>
							<tippy-component
								v-if="feature.title"
								:animate-fill="false"
								arrow
								animation="fade"
								distant="7"
								hideOnClick=true
								interactive
								maxWidth="none"
								placement="left-end"
								theme="light">
								<div class="bs-slc">
									<div class="tippy-tooltip-item-title p-2 text-left" :style="{'white-space':'pre-line'}">{{ feature.title }}</div>
								</div>
							</tippy-component>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { CONSTANTS } from '../resources/constants.js';

export default {
	data() {
		return {
			action: null,
			app: CONSTANTS.AppDescriptor,
			dateYMD: null,
			showTooltip: false,
			showTooltipTimer: false,
			usageTrackerItems: null,
			user: null,
		};
	},

	computed: {
		...mapState([
			'documentationCategories',
			'documentationPackages',
			'documentationSubcategories',
			'families',
			'series',
			'usageTrackerListAllUsers',
			'versions',
		]),
		appUsageItemDates() {
			return [null].concat(this.user.appUsageItems.map((item) => item.dateYMD).sort());
		},

		appUsageItemFiltered() {
			if (!this.user || !this.user.appUsageItems) return null;

			return this.user.appUsageItems.filter((item) => (this.dateYMD ? item.dateYMD === this.dateYMD : item));
		},

		getUsageViewUserSummary() {
			return this.user.getUsageViewUserSummary({ documentationSubcategories: this.documentationSubcategories, documentationPackages: this.documentationPackages, series: this.series, versions: this.versions, families: this.families });
		},

		users() {
			return this.usageTrackerListAllUsers.reduce((acum, { user }) => (acum.includes(user) ? acum : acum.concat([user])), []).sort((a, b) => a.displayName.localeCompare(b.displayName));
		},
	},

	methods: {

		onCreateTippyHandler(instance) {
			instance.show();
		},

		onMouseEnter(action) {
			this.currentAction = null;
			this.showTooltip = false;
			this.showTooltipTimer = setTimeout(() => {
				this.showTooltip = true;
				this.currentAction = action;
			}, 750);
		},

		onMouseLeave() {
			clearTimeout(this.showTooltipTimer);
		},

		onUserSelected() {
			this.dateYMD = null;

			this.user.appUsageItems.forEach((usi) => usi.data.forEach((s) => s.actions.forEach((a) => {
				a.setUsageViewInfo(
					this.documentationCategories,
					this.documentationPackages,
					this.documentationSubcategories,
					this.series,
					this.versions,
				);
			})));
		},
	},
};

</script>

<style lang="scss">
	.tippy-tooltip-item-title {
		box-shadow: 1px 1px 3px #999;
		max-height: 500px;
		overflow-y: auto;
	}
</style>
